import { BackendModel } from "../../core/backend.service";

export class CategoriaDto{

    static path = '/productos/categorias/';

    id: number;
    description: string;

    constructor(){
        this.id= 0;
        this.description = "NUEVA CATEGORÍA"
    }
}


// WEBPACK FOOTER //
// ./src/app/productos/categoria-producto/categoriaDto.model.ts